<template>
  <ph-window>
    <!--Top header bar here-->
    <tool-bar type="header" id="app_header">
      <div style="clear: both">
        <div @click="toggleMenu()">
          <h4 style="float: left">&nbsp;&nbsp;&nbsp;Data Entry</h4>
        </div>
        <div @click="logout()" style="float: right">
          <h4 >Logout</h4>
        </div>
      </div>
      
    </tool-bar>
    <!--Window content here-->
    <window-content>

      <div class="pane-group">
        
        <div v-if="displayMenu" class="pane-sm sidebar">
          <Navigation />
        </div>

        <div class="pane" id="main_pane">
          <router-view />
        </div>

      </div>
    </window-content>
    <!--Bottom footer bar here-->

    <!-- Just removed the footer for now, as it had no purpose
    <tool-bar type="footer">
      
    </tool-bar> -->
  </ph-window>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

var inactivityTime = function () {
    var time;
    window.onload = resetTimer;
    // DOM Events
    document.onmousemove = resetTimer;
    document.onkeypress = resetTimer;

    function logout() {
      // location.href = 'http://dn1.taxicaller.net/dispatch/console.php#/'
    }

    function resetTimer() {
        clearTimeout(time);
        time = setTimeout(logout, 1000 * 60 * 10)
    }
};

export default {
  name: 'Main',
  data: function () {
      return {
          displayMenu : false,
      }
  }, 
  mounted(){
    inactivityTime()
  },
  methods: {
    logout: function(){
      // location.href = 'http://dn1.taxicaller.net/dispatch/console.php#/'
    },
    toggleMenu: function(){
      this.displayMenu = !this.displayMenu
    }
  },
  components: {
		Navigation, 
  },
}
</script>


<style>
  *  {
    -webkit-user-select: auto !important ;  /* Chrome 49+ */
    -moz-user-select: auto !important ;     /* Firefox 43+ */
    -ms-user-select: auto !important ;      /* No support yet */
    user-select: auto !important ;          /* Likely future */   
  }
  @media print {
    .pane-sm, #app_header { display: none; }
    body, #app, #main_pane, .pane, div {
      width: auto;
      height: auto;
      overflow: visible;
      display: inline;
    }
  }
  
</style>
